import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Outlet, useLocation } from 'react-router-dom'

import {
  selectCurrentVariantCohort,
  selectGrowthbookFeatureKey,
  selectIsGrowthbookReady,
  selectLanguage,
} from 'root-redux/selects/common'
import { selectUUID } from 'root-redux/selects/user'

import { useActiveSteps } from 'hooks/useActiveSteps'

import { getPathFromPageId } from 'helpers/getPathFromPageId'

import { goTo } from 'browser-history'

export const SubscribeFlow: React.FC = () => {
  const { search, hash } = useLocation()
  const steps = useActiveSteps()
  const cohort = useSelector(selectCurrentVariantCohort)
  const growthbookFeatureKey = useSelector(selectGrowthbookFeatureKey)
  const isGrowthbookReady = useSelector(selectIsGrowthbookReady)
  const uuid = useSelector(selectUUID)
  const language = useSelector(selectLanguage)
  const firstPageId = steps[0]?.id || ''
  const shouldWaitForGrowthbook = !!growthbookFeatureKey && !isGrowthbookReady

  const firstPagePath = useMemo(
    () =>
      getPathFromPageId({
        pageId: firstPageId,
        cohort,
        uuid,
        language,
        currentSearch: search,
        hash,
      }),
    [firstPageId, cohort, uuid, language, search, hash],
  )

  useEffect(() => {
    const URLParams = new URLSearchParams(search)
    const uuidFromUrl = URLParams.get('uuid')

    if (shouldWaitForGrowthbook || !firstPagePath) {
      return
    }

    if (!uuidFromUrl) {
      goTo(firstPagePath)
    }
  }, [firstPagePath, search, shouldWaitForGrowthbook])

  if (shouldWaitForGrowthbook) {
    return null
  }

  return <Outlet />
}
